<template>
  <div class="qyjs_box">

   <div>
	 <router-view></router-view>
   </div>
    <div class="box">
		<div class="boxA">
			<div class="box-tit"><span>学科评估</span></div>
			<div class="search-t">
				<el-input  placeholder="输入院校名称或学科名称" v-model="queryParams.schoolName"  class="input-with-select" clearable @clear="schGet">
					<el-button type="danger" slot="append" icon="el-icon-search" @click="schGet">搜索</el-button>
				</el-input>
			</div>
		</div>
			<!-- 学校列表 -->
		<div class="schmain">
			 <!-- v-if="schList&&schList.length" v-intersect="handleIntersect"-->
			<!-- <div class="sch-ul" v-if="schList&&schList.length"  ref="scrollContainer" v-intersect="handleIntersect">
				<div class="sch-li" v-for="(item,index) in schList" @click="goInfo(item)">
					<div class="schli-l"><img :src="UPLODE_URL+item.schoolLogo" alt="" /></div>
					<div class="schli-r">
						<div class="schli-rt">
							<span class="schli-rt-a">{{item.schoolName}}</span>
							<span class="schli-rt-b">{{item.schoolCityOne}}·{{item.schoolCityTwo}}</span>
							
						</div>
						<div class="schli-rb">
							<span v-if="item.natureName">{{item.natureName}}</span>
							<span v-if="item.schoolType">{{item.schoolType}}</span>
							<span v-if="item.schoolLevel">{{item.schoolLevel}}</span>
							<span v-if="item.attribute">{{item.attribute}}</span>
							<span v-if="item.unit">{{item.unit}}</span>
							<span v-if="item.oneJihua!=0">{{item.oneJihua!=0?'101计划':''}}</span>
							<span v-if="item.zuoyueJihua==1">{{item.zuoyueJihua==1?'卓越工程师':''}}</span>
							<span v-if="item.youJihua==1">{{item.youJihua==1?'国优计划':''}}</span>
						</div>
					</div>
				</div>
			</div>
			<el-empty v-else :image-size="200"></el-empty> -->
			
			<div class="admit-scoreLine-box-table"  v-intersect="handleIntersect">
				<div class="admit-scoreLine-box-table-th" style="height: 100rpx;display: flex;background: #F5FAFE;width: 100%;height: 50px;line-height: 50px;">
					<div class="admit-scoreLine-box-table-th-div table-lt" style="flex:1;">
						院校名称
					</div>
					<div class="admit-scoreLine-box-table-th-div "style="flex: 1;" >
						学科名称
					</div>
					<div class="admit-scoreLine-box-table-th-div "style="flex: 1;" >
						评估结果
					</div>
					
				</div>
				<div style="border: 1px solid #f0f0f0;" v-if="schList&&schList.length&&user.userVip==1" >
					<div class="admit-scoreLine-box-table-list"
						v-for="(item,index) in schList" :key="index" >
						<div class="admit-scoreLine-box-table-list-div" style="flex:1;">
							{{item.schoolName?item.schoolName:'-'}}
						</div>
						<div class="admit-scoreLine-box-table-list-div">
							{{item.schoolMajor?item.schoolMajor:'-'}}
						</div>
						
						<div class="admit-scoreLine-box-table-list-div admit-scoreLine-box-table-list-divNew">
							<div style="width: 20px;text-align: left;">{{item.grade?item.grade:'-'}}</div>
						</div>
					</div>
				</div>
				<el-empty v-if="user.userVip==1&&!schList" :image-size="200"></el-empty>
				<div v-if="!token&&!user.score"><el-empty description="请先登录完善信息"></el-empty></div>
				<div style="position: relative; min-height: 60vh; padding: 100px 0 0 0px; transform: translate(23%, 10%);">
					<nVip  v-if="user.userVip==0" version="旗舰版" name="就业数据"></nVip>
				</div>
			</div>
			<!-- <el-empty v-else-if="user.userVip==1" :image-size="200"></el-empty> -->
			
		</div>
	</div>
	<div ref="loadMoreTrigger" style="height: 100px;"></div>
    
  </div>
</template>

<script>
	import { EventBus } from '@/utils/event-bus.js';
import { xuemengintro } from "@/api/intoxuemeng";
	import  {UPLODE_URL} from '@/utils/request'
	import nVip from '@/components/n-vip.vue';
export default {
	components: {
		nVip
	},
  data() {
    return {
		UPLODE_URL,
		token: localStorage.getItem('token') || '',
		user: JSON.parse(localStorage.getItem('user')) || '',
      filtrate: {
      	A: ['综合', '工科', '财经', '艺术', '农业', '林业', '医药', '师范', '体育', '语言', '政法', '民族', '军事'],//院校类型
      	B: ['公办', '民办', '独立学院', '中外合作办学', '内地与港澳台地区合作办学', '境外高校独立办学'],//办学性质
      	C: ['985', '211', '研究生院', '双一流', '保研', '双高高职', '示范高职', '骨干高职'],//院校层次
      	D: [],//标签
      	E: [{ id: 1, name: '冲', num: 0 }, { id: 2, name: '稳', num: 0 }, { id: 3, name: '保', num: 0 }, { id: 4, name: '新增' }],
		F:[],
		G: ['是'],
		H: [{name:'101计划',id:'是',quer:'oneJihuas'},{name:'卓越工程师',id:'是',quer:'zuoyueJihuas'},{name:'国优计划',id:'是',quer:'youJihuas'}],
		// {name:'武书连',id:'是',quer:'wushulian'},
		J: [{name:'软科综合',id:'是',quer:'ruanke'},{name:'校友会综合',id:'是',quer:'xiaoyouhui'},{name:'QS',id:'是',quer:'QS'},{name:'US',id:'是',quer:'US'}],
      },
	  schList:[],
	  pageTotal:0,
	  busy: true,

	  // 查询参数
	  queryParams: {
	  	pageNum: 1,
	  	pageSize: 20,
	  	schoolName: '',//学校名
	  },
    };
  },
  directives: {
      intersect: {
        bind(el, binding) {
          const observer = new IntersectionObserver((entries, observer) => {
			  console.log('entries',entries)
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                const img = entry.target;
				console.log('2222sdfsfs',img)
                // 在这里可以做图片的懒加载处理，比如更改src属性
                // img.src = img.dataset.src;
                // 或者触发其他的方法
                // binding.value(entry, observer);
                // observer.unobserve(img); // 停止观察
				// this.createObserver();
              }
            });
          });
   
          observer.observe(el);
        }
      }
    },
  created() {
	  this.token = localStorage.getItem('token') || ''
	  this.user = JSON.parse(localStorage.getItem('user')) || ''
	  // 登录完 确定完 去请求录取接口
	  EventBus.$on("callLoginDialog", () => {
	  	this.token=localStorage.getItem('token')||''
	  	this.user=JSON.parse(localStorage.getItem('user'))||''
	  	this.getList()
	  });
	this.getList()
  },
  mounted() {
	  EventBus.$on('tui', () => {
	      this.token = localStorage.getItem('token')||''
	      this.user=JSON.parse(localStorage.getItem('user'))||''
	  	
	  });
  	 this.createObserver();
	 if(!this.user.score){
	 	EventBus.$emit('showModal');
	 	return
	 }
  },
  beforeDestroy() {
    },
  methods: {
	  // 跳转学校详情
	  goInfo(item){
		  localStorage.setItem('xiaoid',item.id)
		  this.$router.push({path:'/Ainformation/schoolInfo'})
		  return
		  
		const route =this.$router.resolve({name:'schoolInfo',})
		localStorage.setItem('xiaoid',item.id)
		// 打开新窗口并导航至生成的URL
		window.open(route.href, '_blank');
	  },
	  handleIntersect(entry, observer){
		  console.log('11111111111111111111ddd')
		  if (this.queryParams.pageNum >= this.pageTotal ) {
		  	// this.$message({
		  	//   message: '没有更多了',
		  	//   type: 'warning',
		  	//   duration: '4000'
		  	// });
		  	return
		  }
		  // this.busy = true
		  this.queryParams.pageNum++;
		  this.getList('more')
	  },
	  createObserver() {
	        const options = {
	          root: null, // viewport
	          rootMargin: '100px',
	          threshold: 1.0
	        };
	        const observer = new IntersectionObserver(this.handleIntersect, options);
	        observer.observe(this.$refs.loadMoreTrigger);
	      },
	  creat(){
		  
	  },
	  // 获取筛选省份
	   city(){
		   this.api.homeCityListApi().then(res => {this.filtrate.F = res.data})
	   },
	   // 院校所属 点击
	   clickA(item){
		   if(this.queryParams.schoolCityOne == item.name){
		   		this.queryParams.schoolCityOne = ''
		   }else{
		   		this.queryParams.schoolCityOne = item.name
		   }
		   this.queryParams.pageNum = 1;
		   this.getList()
	   },
	   // 院校类型 点击
	   clickB(item){
		   if(this.queryParams.schoolType == item){
			   this.queryParams.schoolType = ''
		   }else{
			   this.queryParams.schoolType = item
		   }
		   this.queryParams.pageNum = 1;
		   this.getList()
	   },
	   // 院校性质 点击
	   clickC(item){
		   if(this.queryParams.natureName == item){
			   this.queryParams.natureName = ''
		   }else{
			   this.queryParams.natureName = item
		   }
		   this.queryParams.pageNum = 1;
		   this.getList()
	   },
	   
	   // 院校层次 点击
	   clickD(item){
	   		   if(this.queryParams.attribute == item){
	   			   this.queryParams.attribute = ''
	   		   }else{
	   			   this.queryParams.attribute = item
	   		   }
			   this.queryParams.pageNum = 1;
	   		   this.getList()
	   },
	   // 院校排名 
	   clickE(item){
	   	if(item.name=='软科综合'){
	   		if(this.queryParams.ruanke == item.quer){
	   			console.log('1111111111')
	   			this.queryParams.ruanke=''
	   			return
	   		}
	   		this.queryParams.ruanke = item.quer
	   		
	   		this.queryParams.xiaoyouhui=''
	   		this.queryParams.qs=''
	   		this.queryParams.us=''
	   		
	   	}
	   	if(item.name=='校友会综合'){
	   		if(this.queryParams.xiaoyouhui == item.quer){
	   			console.log('2222222')
	   			this.queryParams.xiaoyouhui=''
	   			return
	   		}
	   		this.queryParams.xiaoyouhui = item.quer
	   		
	   		
	   		this.queryParams.ruanke = ''
	   		// this.queryParams.xiaoyouhui=''
	   		this.queryParams.qs=''
	   		this.queryParams.us=''
	   	}
	   	if(item.name=='QS'){
	   		if(this.queryParams.qs == item.quer){
	   			console.log('3333333')
	   			this.queryParams.qs=''
	   			return
	   		}
	   		this.queryParams.qs = item.quer
	   		
	   		this.queryParams.ruanke = ''
	   		this.queryParams.xiaoyouhui=''
	   		// this.queryParams.qs=''
	   		this.queryParams.us=''
	   	}
	   	if(item.name=='US'){
	   		if(this.queryParams.us == item.quer){
	   			console.log('3333333')
	   			this.queryParams.us=''
	   			return
	   		}
	   		this.queryParams.us = item.quer
	   		
	   		this.queryParams.qs = ''
	   		this.queryParams.ruanke = ''
	   		this.queryParams.xiaoyouhui=''
	   	}
	   	
	   },
	   clickF(item){
		   if(item.name=='101计划'){
		   	if(this.queryParams.oneJihuas == item.quer){
		   		console.log('1111111111')
		   		this.queryParams.oneJihuas=''
		   		return
		   	}
		   	this.queryParams.oneJihuas = item.quer
		   }
		   if(item.name=='卓越工程师'){
		   	if(this.queryParams.zuoyueJihuas == item.quer){
		   		console.log('2222222')
		   		this.queryParams.zuoyueJihuas=''
		   		return
		   	}
		   	this.queryParams.zuoyueJihuas = item.quer
		   }
		   if(item.name=='国优计划'){
		   	if(this.queryParams.youJihuas == item.quer){
		   		console.log('3333333')
		   		this.queryParams.youJihuas=''
		   		return
		   	}
		   	this.queryParams.youJihuas = item.quer
		   }
	   },
	   
	   schGet(){
		   console.log('1111111',this.user.score)
		   if(!this.user.score){
		   	EventBus.$emit('showModal');
		   	return
		   }
		   this.queryParams.pageNum = 1;
		   this.getList()
	   },
	   // handleScroll(e) {
		  //  console.log('11111',e)
	   //       const bottomOffset = 50; // 距离底部多少像素时触发加载
	   //       const scrollContainer = this.$refs.scrollContainer;
	   //       if (scrollContainer.scrollHeight - (scrollContainer.scrollTop + scrollContainer.clientHeight) < bottomOffset) {
	   //         this.getList();
	   //       }
	   //     },
	   // 数据列表请求
	   getList(type){
		   if(this.user.userVip==0){
		   	return
		   }
		   let qu = {
			   schoolName:this.queryParams.schoolName,
			   // city:this.addShowData.cityId=='全国'?'':this.addShowData.cityId,
			   pageNum:this.queryParams.pageNum,
			   // currentPage:this.news_page,
			   // size:5,
			   pageSize:20,
			  
		   }
		   
		   
		    this.api.homeSchoolGradeApi(qu).then(res => {
				if(res.code==200){
					
					if (type == 'more') {
						if (!res.data) {
							this.$message({
								message: '没有更多了',
								type: 'warning',
								duration: '4000'
							});
							return
						}
						this.schList = [...this.schList, ...res.data.rows];
						
					}else{
						this.schList = []
						this.schList = res.data ? res.data.rows : [];
						// this.dataText = res.data ? '' : '暂无数据'; //进去页面先让字样为空
						this.pageTotal = res.data ? res.data.pageTotal : 0;
					}
					
					
					// if(res.data&&res.data.rows){
					// 	this.pageTotal = res.data.pageTotal
					// 	this.schList = res.data.rows;
						
					// 	// this.schList = [...this.schList, ...res.data.rows];
						
					// }else{
					// 	this.schList = []
					// }
				}else{
					 this.$message.error(res.msg);
				}
			})
	   }
  },
};
</script>

<style lang="scss" scoped>
.img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


.box{
	/deep/.el-form-item__content{
		flex: 1;
	}
	.el-form-item--small.el-form-item {
		margin-bottom: 5px;
	}
	// height: 100vh;
	// min-height: 30vh;
	.boxA{
		background: #fff;
		border-radius: 10px;
		padding: 10px 20px 20px 20px;
		margin-top: 10px;
		.box-tit{
			width: 100%;
			height: 40px;
			line-height: 40px;
			border-bottom: 1px solid #F44F4D;
			margin-bottom: 15px;
			span{
				width: 140px;
				height: 40px;
				line-height: 40px;
				background-color: #F44F4D;
				color: #fff;
				display: block;
				border-radius: 10px 10px 0 0;
				text-align: center;
				font-size: 15px;
			}
		}
		
		.search-t{
			width: 30%;
			margin-bottom: 10px;
			.input-with-select{
				border-radius: 4px;
				/deep/.el-input__inner{
					border-color: #F56C6C!important;
				}
				/deep/.el-button--danger{
					border: none!important;
				}
				/deep/.el-button{
					border: 1px solid #f44f4d!important;
					background: #f44f4d;
					color: #fff;
					border-radius: 0  4px 4px 0px;
				}
			}
		}
		
		.topsec{
			
			.kuai{
				display: flex;
				flex-wrap: wrap;
				span{
					margin-right: 20px;
					cursor: pointer;
				}
				span.onsele{
					color: #F44F4D;
				}
			}
			.el-form-item {
				display: flex;
			}
		}
	}
	
	// <div class="schmain">
	// 	<div class="sch-ul">
	// 		<div class="sch-li">
	// 			<div class="schli-l"><img src="../../assets/1.png" alt="" /></div>
	// 			<div class="schli-r">
	// 				<div class="schli-rt"><span class="schli-rt-a">天津大学</span><span class="schli-rt-b">dizhi</span></div>
	// 				<div class="schli-rb"><span>benke </span></div>
	// 			</div>
	// 		</div>
	// 	</div>
	// </div>
	.schmain{
		margin-top: 12px;
		background: #fff;
		padding: 10px;
		border-radius: 10px;
		.sch-ul{
			.sch-li:hover{
				.schli-rt-a{
					color: #F44F4D;
				}
			}
			.sch-li{
				
				background: #fff;
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				padding: 20px;
				border-radius: 10px;
				cursor: pointer;
				.schli-l{
					width: 60px;
					height: 60px;
					margin-right: 20px;
					img{
						width: 60px;
						height: 60px;
						border-radius: 50%;
					}
				}
				.schli-r{
					flex: 1;
					.schli-rt{
						display: flex;
						align-items: center;
						margin-bottom: 10px;
						.schli-rt-a{
							font-size: 22px;
						}
						.schli-rt-b{
							margin-left: 10px;
							    height: 25px;
								line-height: 25px;
							    border-radius: 26px;
							    border: 1px solid #d8d8d8;
							    padding: 0 10px;
							    font-size: 12px;
							    color: #666;
						}
					}
					.schli-rb{
						margin-top: 6px;
						span{
							    height: 22px;
							    padding: 0 8px;
							    border-radius: 4px;
							    background: #f5f6f7;
							    font-size: 14px;
							    color: #666;
							    margin-right: 8px;
						}
					}
				}
			}
		}
	}
}
.admit-scoreLine-box-table-th{
				margin-bottom: 10px;
			}
			.admit-scoreLine-box-table-list{
				width: 100%;
				display: flex;
				.admit-scoreLine-box-table-list-div{
					flex: 1;
					// margin-bottom: 6px;
					font-size: 13px;
					text-align: center;
					line-height: 40px;
					    border-bottom: 1px solid #f0f0f0;
				}
				
			}
.admit-scoreLine-box-table-th-div{
	font-size: 14px;
	text-align: center;
}
.admit-scoreLine-box-table-list-divNew{
	justify-content: center;
	    display: flex;
}
</style>